import type { AccountData } from '../../../types/external'
import flyoutOnboardingFormData from '../../../mocks/flyouOnboardingMockData.json'
import { AWSPartnershipType, FlyoutOnboardingPartnershipType } from '../types'

export const setInitialPartnerData = (partnerData: AccountData) => {
  const initialFlyoutOnboardingFormData = JSON.parse(
    JSON.stringify(flyoutOnboardingFormData)
  )
  const consultingPartnerISVLabraSharingTerm = {
    label:
      'I agree to provide my ISV partners on Labra with offer details linked to their products',
    value: false,
    type: 'checkbox',
  }
  if (partnerData.partnershipType) {
    if (
      partnerData.partnershipType.includes(
        AWSPartnershipType.TECHNOLOGY_PARTNER
      ) &&
      partnerData.partnershipType.includes(
        AWSPartnershipType.CONSULTING_PARTNER
      )
    ) {
      initialFlyoutOnboardingFormData.labra_partner_details.partnership_type = [
        FlyoutOnboardingPartnershipType.ISV,
        FlyoutOnboardingPartnershipType.CP,
      ]
      initialFlyoutOnboardingFormData.terms_and_conditions.labra_partner_details.push(
        consultingPartnerISVLabraSharingTerm
      )
    } else if (
      partnerData.partnershipType.includes(
        AWSPartnershipType.TECHNOLOGY_PARTNER
      )
    ) {
      initialFlyoutOnboardingFormData.labra_partner_details.partnership_type = [
        FlyoutOnboardingPartnershipType.ISV,
      ]
    } else {
      initialFlyoutOnboardingFormData.labra_partner_details.partnership_type = [
        FlyoutOnboardingPartnershipType.CP,
      ]
      initialFlyoutOnboardingFormData.terms_and_conditions.labra_partner_details.push(
        consultingPartnerISVLabraSharingTerm
      )
    }
  }
  return initialFlyoutOnboardingFormData
}
